import { render, staticRenderFns } from "./box-list.vue?vue&type=template&id=2d3395e4&"
import script from "./box-list.vue?vue&type=script&lang=ts&"
export * from "./box-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports